import type { CategoriesRecoPlaylist } from '../../interfaces/msCatalogCategory';
import type { Recommendations } from '../../interfaces/productRecommendation';

// spx
export const FETCH_RECO_CATEGORIES =
  'productDiscovery/recommendations/categoriesRecommendations/FETCH_RECO_CATEGORIES';
export const FETCH_RECO_CATEGORIES_SUCCESS =
  'productDiscovery/recommendations/categoriesRecommendations/FETCH_RECO_CATEGORIES_SUCCESS';
export const FETCH_RECO_CATEGORIES_FAILED =
  'productDiscovery/recommendations/categoriesRecommendations/FETCH_RECO_CATEGORIES_FAILED';

export const FETCH_RECO_TOP_SALES_CATEGORIES =
  'productDiscovery/recommendations/categoriesRecommendations/FETCH_RECO_TOP_SALES_CATEGORIES';
export const FETCH_RECO_TOP_SALES_CATEGORIES_SUCCESS =
  'productDiscovery/recommendations/categoriesRecommendations/FETCH_RECO_TOP_SALES_CATEGORIES_SUCCESS';
export const FETCH_RECO_TOP_SALES_CATEGORIES_FAILED =
  'productDiscovery/recommendations/categoriesRecommendations/FETCH_RECO_TOP_SALES_CATEGORIES_FAILED';

export interface FetchRecoCategories {
  type: typeof FETCH_RECO_CATEGORIES;
}

export const fetchRecoCategories = (): FetchRecoCategories => ({
  type: FETCH_RECO_CATEGORIES,
});

export interface FetchRecoCategoriesSuccess {
  type: typeof FETCH_RECO_CATEGORIES_SUCCESS;
  recommendations: CategoriesRecoPlaylist[];
}

export const fetchRecoCategoriesSuccess = (
  recommendations: CategoriesRecoPlaylist[],
): FetchRecoCategoriesSuccess => ({
  type: FETCH_RECO_CATEGORIES_SUCCESS,
  recommendations,
});

export interface FetchRecoCategoriesFailed {
  type: typeof FETCH_RECO_CATEGORIES_FAILED;
  error: Error;
}

export const fetchRecoCategoriesFailed = (
  error: Error,
): FetchRecoCategoriesFailed => ({
  type: FETCH_RECO_CATEGORIES_FAILED,
  error,
});

export interface FetchRecoTopSalesCategories {
  type: typeof FETCH_RECO_TOP_SALES_CATEGORIES;
}

export const fetchRecoTopSalesCategories = (): FetchRecoTopSalesCategories => ({
  type: FETCH_RECO_TOP_SALES_CATEGORIES,
});

export interface FetchRecoTopSalesCategoriesSuccess {
  type: typeof FETCH_RECO_TOP_SALES_CATEGORIES_SUCCESS;
  topSalesCategoriesRecommendations: Recommendations[];
}

export const fetchRecoTopSalesCategoriesSuccess = (
  topSalesCategoriesRecommendations: Recommendations[],
): FetchRecoTopSalesCategoriesSuccess => ({
  type: FETCH_RECO_TOP_SALES_CATEGORIES_SUCCESS,
  topSalesCategoriesRecommendations,
});

export interface FetchRecoTopSalesCategoriesFailed {
  type: typeof FETCH_RECO_TOP_SALES_CATEGORIES_FAILED;
  error: Error;
}

export const fetchRecoTopSalesCategoriesFailed = (
  error: Error,
): FetchRecoTopSalesCategoriesFailed => ({
  type: FETCH_RECO_TOP_SALES_CATEGORIES_FAILED,
  error,
});

export type Action =
  | FetchRecoCategories
  | FetchRecoCategoriesSuccess
  | FetchRecoCategoriesFailed
  | FetchRecoTopSalesCategories
  | FetchRecoTopSalesCategoriesSuccess
  | FetchRecoTopSalesCategoriesFailed;
